<template>
  <div class="app-layout orver-hidden-x">
    <el-row type="flex" class="flex-justify-between flex-align-center">
      <strong class="font-size-24">核心数据</strong>
      <el-date-picker
        v-model="queryForm.analyzeTime"
        align="right"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        @change="search"
        :clearable="false"
      >
      </el-date-picker>
    </el-row>
    <el-row class="margin-top-15">
      <el-card class="box-card" shadow="never" v-loading="queryFlowLoading">
        <div slot="header" class="clearfix">
          <span class="font-size-14">流量数据</span>
        </div>
        <el-row type="flex" class=" flex-align-center">
          <el-col>
            <p>
              浏览量(PV)
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content">页面浏览数，同个访客访问多次页面，记录为多个pv。</div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </p>
            <!-- eslint-disable-next-line max-len -->
            <p class="margin-top-20">
              <strong class="font-size-24">{{ queryFlowData.pv }}</strong>
            </p>
          </el-col>
          <el-col>
            <p>
              访客数(UV)
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content">页面访客数，同个访客访问多次页面，记录为1个uv。</div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </p>
            <!-- eslint-disable-next-line max-len -->
            <p class="margin-top-20">
              <strong class="font-size-24">{{ queryFlowData.uv }}</strong>
            </p>
          </el-col>
          <el-col>
            <p>
              新访客
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content">当天新增的访客。</div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </p>
            <!-- eslint-disable-next-line max-len -->
            <p class="margin-top-20">
              <strong class="font-size-24">{{ queryFlowData.newUser }}</strong>
            </p>
          </el-col>
          <el-col>
            <p>
              IP数
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content">浏览页面的ip数。</div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </p>
            <!-- eslint-disable-next-line max-len -->
            <p class="margin-top-20">
              <strong class="font-size-24">{{ queryFlowData.ip }}</strong>
            </p>
          </el-col>
          <el-col>
            <p>
              频次（人均）
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content">
                  访客平均浏览页面次数。
                  <br />
                  计算公式：pv / uv
                </div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </p>
            <!-- eslint-disable-next-line max-len -->
            <p class="margin-top-20">
              <strong class="font-size-24">{{ queryFlowData.visitScale }}</strong>
            </p>
          </el-col>
          <el-col v-if="source !== 'BPS/BPS1'">
            <p>
              跳出率
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content">
                  跳出事件：访客启动应用后，没有进行任何操作即退出应用，记录为1次跳出事件。
                  <br />
                  计算公式：（跳出次数 / 启动次数） * 100%
                </div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </p>
            <!-- eslint-disable-next-line max-len -->
            <p class="margin-top-20">
              <strong class="font-size-24"
                >{{ (queryFlowData.quickExitScale * 100).toFixed(2) }}%</strong
              >
            </p>
          </el-col>
        </el-row>
      </el-card>
    </el-row>
    <el-row class="margin-top-15">
      <el-card class="box-card" shadow="never" v-loading="queryUserCountLoading">
        <div slot="header" class="clearfix">
          <p class="font-size-14">
            用户量统计
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content">统计当天的总用户数和新旧用户数。</div>
              <i class="el-icon-info"></i>
            </el-tooltip>
          </p>
        </div>
        <div id="barChart" class="chart-box user-chart-box"></div>
      </el-card>
    </el-row>
    <el-row type="flex" class="margin-top-15" style="margin-right: -20px; flex-flow: wrap;">
      <el-col :span="24" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  页面访问量趋势
                  <el-tooltip class="item" effect="dark" placement="right">
                    <!-- eslint-disable-next-line max-len -->
                    <div slot="content">
                      1. 用户访问一次页面，增加一个PV数据。 <br />2.
                      数量代表展示时段的总和，仅供参考，实际数据请看「今日流量」
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <!-- <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div> -->
              </el-col>
              <!-- <el-col align="right">
                <p class="color-green"><strong>9234.3%<i class="el-icon-top"></i></strong></p>
                <div class="font-size-12">
                  较一周前
                </div>
              </el-col> -->
            </el-row>
          </div>
          <div id="lineChartPv" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="24" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  用户活跃量趋势
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="这是用户每小时的活跃量数据，这里主要表现变化趋势，并非UV数据，UV数据请看上边。"
                    placement="right"
                  >
                    <div slot="content">
                      这是用户每小时的活跃量数据，这里主要表现变化趋势，<br />并非UV数据，UV数据请看上边。
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <!-- <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div> -->
              </el-col>
              <!-- <el-col align="right">
                <p class="color-green"><strong>9234.3%<i class="el-icon-top"></i></strong></p>
                <div class="font-size-12">
                  较一周前
                </div>
              </el-col> -->
            </el-row>
          </div>
          <div id="lineChartUv" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>

      <el-col :span="24" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  新用户活跃量趋势
                  <el-tooltip class="item" effect="dark" width="200px" placement="right">
                    <!-- eslint-disable-next-line max-len -->
                    <div slot="content">
                      1. 用户清理了缓存数据，下次进来程序也会认为是新访客。<br />2.
                      数量代表展示时段的总和，仅供参考，实际数据请看「今日流量」
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <!-- <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div> -->
              </el-col>
              <!-- <el-col align="right">
                <p class="color-green"><strong>9234.3%<i class="el-icon-top"></i></strong></p>
                <div class="font-size-12">
                  较一周前
                </div>
              </el-col> -->
            </el-row>
          </div>
          <div id="lineChartNew" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="24" class="padding-right-20 padding-bottom-20" v-if="source !== 'BPS/BPS1'">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  跳出率趋势
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">只访问了入口页面就离开的用户比例。</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div>
              </el-col>
              <!-- <el-col align="right">
                <p class="color-green"><strong>9234.3%<i class="el-icon-top"></i></strong></p>
                <div class="font-size-12">
                  较一周前
                </div>
              </el-col> -->
            </el-row>
          </div>
          <div id="lineChartJump" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  用户平均停留时长
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">用户在页面停留的平均时长</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div id="barChartStay" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  新用户次日留存率
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">
                      昨天的新用户，到第二天的留存率。<br />（就是第二天的回头客）
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div id="lineChartRetention" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row type="flex" class=" flex-align-center margin-top-20">
      <strong class="font-size-24">综合数据</strong>
    </el-row>
    <el-row type="flex" class="margin-top-15" style="margin-right: -20px; flex-flow: wrap;">
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  设备型号用户量Top 10
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">不同设备型号的用户量分布情况</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTimeLastDay }}
                </div>
              </el-col>
              <!-- <el-col align="right">
                <p class="color-green"><strong>9234.3%<i class="el-icon-top"></i></strong></p>
                <div class="font-size-12">
                  较一周前
                </div>
              </el-col> -->
            </el-row>
          </div>
          <div id="barChartTopEquipment" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  城市名称访问用户量Top 10
                  <el-tooltip class="item" effect="dark" placement="right">
                    <!-- eslint-disable-next-line max-len -->
                    <div slot="content">
                      <!-- eslint-disable-next-line max-len -->
                      在不同城市使用App的用户量分布情况。<br />ps: 城市是根据ip地址查询出来的，<br />并不是每个ip都能查询出来，<br />查询出来的结果也未必准确，只作为趋势参考。
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTimeLastDay }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div id="barChartTopCity" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  系统版本用户量Top 10
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">不同系统版本的用户量分布情况。</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTimeLastDay }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div id="barChartTopSystem" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  应用版本访问用户量Top 10
                  <el-tooltip class="item" effect="dark" placement="right">
                    <!-- eslint-disable-next-line max-len -->
                    <div slot="content">
                      发布程序版本号的分布，可以看出使<br />用新版本和老版本的用户量，方便排查<br />问题。记得要更新你们项目的版本<br />号哦。
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTimeLastDay }}
                </div>
              </el-col>
              <!-- <el-col align="right">
                <p class="color-green"><strong>9234.3%<i class="el-icon-top"></i></strong></p>
                <div class="font-size-12">
                  较一周前
                </div>
              </el-col> -->
            </el-row>
          </div>
          <div id="barChartTopApp" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  设备分辨率量Top 10
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">数值代表设备的物理分辨率。</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTimeLastDay }}
                </div>
              </el-col>
              <!-- <el-col align="right">
                <p class="color-green"><strong>9234.3%<i class="el-icon-top"></i></strong></p>
                <div class="font-size-12">
                  较一周前
                </div>
              </el-col> -->
            </el-row>
          </div>
          <div id="barChartTopResolving" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="padding-right-20 padding-bottom-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row type="flex" class=" flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  浏览器访问用户量Top 10
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">不同浏览器的用户量分布情况。</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTimeLastDay }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div id="barChartTopBrowser" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  queryFlowData,
  queryUserCount,
  queryPvTendency,
  queryUvTendency,
  queryNewUserTendency,
  queryQuickExitScaleTendency,
  queryPageDurationTendency,
  queryKeepUserTendency,
  queryTopAnalyze,
} from '@/api/log/index';
import { parseTime } from '@/utils';
import { LogTopType, LogChartTopType } from '@/data/log/index';

export default {
  name: 'LogIndex',
  data() {
    return {
      timeoutEvent: null,
      chartData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
        ],
      },
      queryForm: {
        analyzeTime: parseTime(new Date(), 'yyyy-MM-dd'),
        analyzeTimeLastDay: '',
      },
      queryFlowLoading: false,
      queryUserCountLoading: false,
      queryComprehensiveLoading: false,
      queryFlowData: {
        uv: 0,
        pv: 0,
        newUser: 0,
        ip: 0,
        quickExitScale: 0,
        visitScale: 0,
      },
      barChart: null,
      lineChartPv: null,
      lineChartUv: null,
      lineChartNew: null,
      lineChartJump: null,
      barChartStay: null,
      lineChartRetention: null,
      barChartTopEquipment: null, // 设备型号用户量Top 10
      barChartTopCity: null, // 城市名称访问用户量Top 10
      barChartTopSystem: null, // 系统版本用户量Top 10
      barChartTopApp: null, // 应用版本访问用户量Top 10
      barChartTopResolving: null, // 设备分辨率量Top 10
      barChartTopBrowser: null, // 浏览器Top 10
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.barChart = this.$echarts.init(document.getElementById('barChart'));
    this.lineChartPv = this.$echarts.init(document.getElementById('lineChartPv'));
    this.lineChartUv = this.$echarts.init(document.getElementById('lineChartUv'));
    this.lineChartNew = this.$echarts.init(document.getElementById('lineChartNew'));
    if (this.source !== 'BPS/BPS1') {
      this.lineChartJump = this.$echarts.init(document.getElementById('lineChartJump'));
    }
    this.barChartStay = this.$echarts.init(document.getElementById('barChartStay'));
    this.lineChartRetention = this.$echarts.init(document.getElementById('lineChartRetention'));
    this.barChartTopEquipment = this.$echarts.init(document.getElementById('barChartTopEquipment'));
    this.barChartTopCity = this.$echarts.init(document.getElementById('barChartTopCity'));
    this.barChartTopSystem = this.$echarts.init(document.getElementById('barChartTopSystem'));
    this.barChartTopApp = this.$echarts.init(document.getElementById('barChartTopApp'));
    this.barChartTopResolving = this.$echarts.init(document.getElementById('barChartTopResolving'));
    this.barChartTopBrowser = this.$echarts.init(document.getElementById('barChartTopBrowser'));

    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  computed: {
    ...mapGetters('app', ['source', 'env', 'bizChannel']),
  },
  watch: {
    source: {
      handler() {
        this.search();
      },
      immediate: true,
    },
    env: {
      handler() {
        this.search();
      },
    },
  },
  methods: {
    async search() {
      try {
        this.queryUserCount();
        this.searchChartData();
        this.queryFlowLoading = true;
        const {
          source,
          env,
          queryForm: { analyzeTime },
        } = this;

        if (!source || !env) {
          return;
        }

        const { data } = await queryFlowData({
          analyzeTime,
        });

        // eslint-disable-next-line object-curly-newline, max-len
        const { uv = 0, pv = 0, newUser = 0, ip = 0, quickExitScale = 0, visitScale = 0 } = data || {};

        this.queryFlowData = {
          uv,
          pv,
          newUser,
          ip,
          quickExitScale,
          visitScale,
        };
      } catch (e) {
        console.log(e);
      } finally {
        this.queryFlowLoading = false;
      }
    },
    async searchChartData() {
      const {
        source,
        env,
        queryForm: { analyzeTime },
      } = this;

      if (!source || !env) {
        return;
      }

      const analyzeTimeFrom = parseTime(new Date(new Date(analyzeTime).getTime()), 'yyyy-MM-dd');
      const referAnalyzeTime = parseTime(
        new Date(new Date(analyzeTimeFrom).getTime() - 604800000),
        'yyyy-MM-dd',
      );

      // 趋势
      this.renderTrendData({ source, env }, analyzeTime, analyzeTimeFrom, referAnalyzeTime);
      // 停留、存活率
      this.renderDurationAndKeepData({ source, env }, analyzeTime, referAnalyzeTime);
      // 综合数据
      this.renderComprehensiveData({ source, env }, analyzeTime);
    },
    async renderTrendData(_env, analyzeTime, analyzeTimeFrom, referAnalyzeTime) {
      const params = {
        analyzeTimeFrom: `${analyzeTimeFrom} 00`,
        analyzeTimeTo: `${analyzeTime} 23`,
        referAnalyzeTime,
      };

      const promiseArr = [
        await this.renderPromiseMethods(queryPvTendency, params),
        await this.renderPromiseMethods(queryUvTendency, params),
        await this.renderPromiseMethods(queryNewUserTendency, params),
      ];
      if (this.source !== 'BPS/BPS1') {
        promiseArr.push(await this.renderPromiseMethods(queryQuickExitScaleTendency, params));
      }
      Promise.all(promiseArr).then((res) => {
        res.forEach((item, index) => {
          if (item) {
            const {
              data: {
                pvs, uvs, newUsers, quickExitScales,
              },
            } = item;
            let array = [];
            let chartType = '';
            // eslint-disable-next-line default-case
            switch (index) {
              case 0:
                array = pvs;
                chartType = 'lineChartPv';
                break;
              case 1:
                array = uvs;
                chartType = 'lineChartUv';
                break;
              case 2:
                array = newUsers;
                chartType = 'lineChartNew';
                break;
              case 3:
                array = quickExitScales;
                chartType = 'lineChartJump';
                break;
            }

            const yArray = [];
            const xArray = [];
            // const xReferArray = [];
            const yReferArray = [];
            const curHours = new Date().getHours();
            const isSameDate = parseTime(new Date(`${params.analyzeTimeFrom}:00:00`), 'yyyy-MM-dd')
              === parseTime(new Date(new Date().getTime()), 'yyyy-MM-dd');

            array.forEach(({ currentAnalyzeTime, current, refer }, eindex) => {
              xArray.push(currentAnalyzeTime.replace(/:00:00/g, ''));
              // xReferArray.push(referAnalyzeTime);
              if (curHours >= eindex || !isSameDate) {
                yArray.push(index === 3 ? (current * 100).toFixed(2) : current);
                yReferArray.push(refer);
              }
            });

            // eslint-disable-next-line no-unused-expressions
            this[chartType] && this[chartType].clear(); // 消除当前实例
            const option = this.renderTrendChart(xArray, yArray, yReferArray, index);
            this[chartType].setOption(option);
          }
        });
      });
    },
    async renderDurationAndKeepData({ source, env }, analyzeTime, analyzeTimeFrom) {
      const params = {
        analyzeTimeFrom: `${analyzeTimeFrom}`,
        analyzeTimeTo: `${analyzeTime}`,
      };
      if (!source || !env) {
        return;
      }
      Promise.all([
        await this.renderPromiseMethods(queryPageDurationTendency, params),
        await this.renderPromiseMethods(queryKeepUserTendency, params),
      ]).then((res) => {
        res.forEach((item, index) => {
          if (item) {
            const {
              data: { pageDurations, keepUsers },
            } = item;
            const array = keepUsers || pageDurations || [];
            const chartType = index ? 'lineChartRetention' : 'barChartStay';
            const methodType = index ? 'renderLineChartRetention' : 'renderbarChartStay';

            const yArray = [];
            const xArray = [];
            array.forEach(({ currentAnalyzeTime, current }) => {
              yArray.push(index ? (current * 100).toFixed(2) : (current / 1000).toFixed(0));
              xArray.push(currentAnalyzeTime);
            });

            // eslint-disable-next-line no-unused-expressions
            this[chartType] && this[chartType].clear(); // 消除当前实例
            const option = this[methodType](xArray, yArray);
            this[chartType].setOption(option);
          }
        });
      });
    },
    async renderComprehensiveData({ source, env }, analyzeTime) {
      try {
        const analyzeTimeLastDay = parseTime(
          new Date(new Date(analyzeTime).getTime() - 86400000),
          'yyyy-MM-dd',
        );
        const params = {
          analyzeTime: analyzeTimeLastDay,
        };
        this.queryForm.analyzeTimeLastDay = analyzeTimeLastDay;
        this.queryComprehensiveLoading = true;
        if (!source || !env) {
          return;
        }
        Promise.all([
          await this.renderPromiseMethods(queryTopAnalyze, {
            ...params,
            topType: LogTopType['设备型号用户量'],
          }),
          await this.renderPromiseMethods(queryTopAnalyze, {
            ...params,
            topType: LogTopType['城市名称访问用户量'],
          }),
          await this.renderPromiseMethods(queryTopAnalyze, {
            ...params,
            topType: LogTopType['系统版本用户量'],
          }),
          await this.renderPromiseMethods(queryTopAnalyze, {
            ...params,
            topType: LogTopType['应用版本访问用户量'],
          }),
          await this.renderPromiseMethods(queryTopAnalyze, {
            ...params,
            topType: LogTopType['设备分辨率量'],
          }),
          await this.renderPromiseMethods(queryTopAnalyze, {
            ...params,
            topType: LogTopType['浏览器访问用户量'],
          }),
        ]).then((res) => {
          res.forEach((item, index) => {
            if (item) {
              const {
                data: { topInfos },
              } = item;

              if (topInfos) {
                const nameArray = [];
                const countArray = [];
                topInfos.forEach(({ name, count }) => {
                  nameArray.push(name);
                  countArray.push(count);
                });
                const topType = LogTopType[index + 1];
                const chartType = LogChartTopType[topType];

                // eslint-disable-next-line no-unused-expressions
                this[chartType] && this[chartType].clear(); // 消除当前实例
                const option = this.renderBarChartOptions(nameArray, countArray);
                this[chartType].setOption(option);
              }
            }
          });
          this.queryComprehensiveLoading = false;
        });
      } catch (e) {
        this.queryComprehensiveLoading = false;
      }
    },
    async renderPromiseMethods(method, params) {
      try {
        const res = await method(params);
        return res;
      } catch (e) {
        return null;
      }
    },
    async queryUserCount() {
      try {
        this.queryUserCountLoading = true;
        const {
          env,
          source,
          queryForm: { analyzeTime: analyzeTimeTo },
        } = this;
        if (!env || !source) {
          return;
        }
        // const analyzeTimeTo = `${analyzeTime} ${parseTime(new Date(), 'HH:mm')}`;
        const analyzeTimeFrom = parseTime(
          new Date(new Date(analyzeTimeTo).getTime() - 2592000000),
          'yyyy-MM-dd',
        );
        const { data } = await queryUserCount({
          analyzeTimeFrom,
          analyzeTimeTo,
        });
        const analyzeDateArray = [];
        const newUserArray = [];
        const totalUserArray = [];
        const oldUserArray = [];
        (data.userCounts || []).forEach(({
          analyzeDate, newUser, oldUser, userTotal,
        }) => {
          analyzeDateArray.push(analyzeDate);
          newUserArray.push(newUser);
          oldUserArray.push(oldUser);
          totalUserArray.push(userTotal);
        });
        this.renderBarChart(analyzeDateArray, newUserArray, oldUserArray, totalUserArray);
      } catch (e) {
        console.log(e);
      } finally {
        this.queryUserCountLoading = false;
      }
    },
    renderTrendChart(xArray, yArray, yReferArray, index) {
      return {
        // 平滑
        smooth: true,
        tooltip: {
          trigger: 'axis',
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          axisPointer: {
            type: 'line',
            axis: 'x',
            label: {
              show: true,
              color: 'rgb(255, 151, 36)',
              backgroundColor: 'rgba(255, 255, 255, .8)',
              shadowBlur: 0,
              margin: 0,
            },
            lineStyle: {
              type: 'dashed',
              color: '#b6b5b7',
            },
          },
          textStyle: {
            color: '#333',
            align: 'left',
            fontSize: 14,
          },
          formatter(params) {
            const res = `
              <div style="
                padding: 10px;
                box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                background: #fff;
                border-radius: 5px;">
                <div style="min-width: 120px;">
                  <p>${params[0].axisValueLabel}</p>
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <p><span style="display: inline-block;margin-right: 5px;border-radius: 10px;height: 10px; width: 10px;background-color: ${
  params[0].color
};"></span>${params[0].seriesName}</p>
                    <p>${params[0].value}${index === 3 ? '%' : ''}</p>
                  </div>
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <p><span style="display: inline-block;margin-right: 5px;border-radius: 10px;height: 10px; width: 10px;background-color: ${
  params[1].color
};"></span>${params[1].seriesName}</p>
                    <p>${params[1].value}${index === 3 ? '%' : ''}</p>
                  </div>
                </div>
              </div>`;
            return res;
          },
          position(point, params, dom, rect, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            const x = point[0]; //
            const y = point[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];
            let posX = 0; // x坐标位置
            let posY = 0; // y坐标位置

            if (x < boxWidth) {
              // 左边放不开
              posX = 5;
            } else {
              // 左边放的下
              posX = x - boxWidth;
            }

            if (y < boxHeight) {
              // 上边放不开
              posY = 5;
            } else {
              // 上边放得下
              posY = y - boxHeight;
            }

            return [posX, posY];
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {},
          },
        },
        grid: {
          height: '200',
          left: '0%',
          right: '2%',
          bottom: '4%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xArray,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#b6b5b7', // 坐标值得具体的颜色
            },
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: index === 3 ? '{value} %' : '{value}',
            textStyle: {
              color: '#b6b5b7', // 坐标值得具体的颜色
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 10,
          },
          {
            start: 0,
            end: 10,
          },
        ],
        series: [
          {
            name: '一周前',
            type: 'line',
            smooth: true, // 设置折线图平滑
            lineStyle: {
              width: 4,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              color: 'rgb(174, 189, 238)',
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(171, 185, 249)',
                },
                {
                  offset: 1,
                  color: 'rgb(251, 252, 255)',
                },
              ]),
            },
            data: yReferArray,
          },
          {
            name: '当前',
            type: 'line',
            smooth: true, // 设置折线图平滑
            lineStyle: {
              width: 4,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              color: 'rgb(255, 151, 36)',
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 186, 110)',
                },
                {
                  offset: 1,
                  color: 'rgb(255, 253, 252)',
                },
              ]),
            },
            data: yArray,
          },
        ],
      };
    },
    renderBarChartOptions(nameArray, countArray) {
      return {
        color: ['#3695ff'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          height: '200',
          left: '0%',
          right: '4%',
          bottom: '8%',
          containLabel: true,
        },
        xAxis: {
          position: 'top',
          type: 'value',
          // 网格
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: '#bfbfbf',
            },
          },
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          axisLabel: {
            textStyle: {
              color: '#7f767f', // 坐标值得具体的颜色
            },
          },
        },
        yAxis: {
          inverse: true,
          data: nameArray,
          type: 'category',
          // 网格
          splitLine: {
            show: false,
          },
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#b6b5b7', // 坐标值得具体的颜色
            },
            formatter(params) {
              let newParamsName = ''; // 最终拼接成的字符串
              const paramsNameNumber = params.length; // 实际标签的个数
              const provideNumber = 11; // 每行能显示的字的个数
              const rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                // eslint-disable-next-line no-plusplus
                for (let p = 0; p < rowNumber; p++) {
                  let tempStr = ''; // 表示每一次截取的字符串
                  const start = p * provideNumber; // 开始截取的位置
                  const end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (`${p}` === `${rowNumber - 1}`) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = `${params.substring(start, end)}\n`;
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              // 将最终的字符串返回
              return newParamsName;
            },
          },
        },
        series: [
          {
            barWidth: 12, // 柱图宽度
            data: countArray,
            type: 'bar',
          },
        ],
      };
    },
    renderLineChartRetention(xArray, yArray) {
      return {
        // 平滑
        smooth: true,
        tooltip: {
          trigger: 'axis',
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          axisPointer: {
            type: 'line',
            axis: 'x',
            label: {
              show: true,
              color: 'rgb(255, 151, 36)',
              backgroundColor: 'rgba(255, 255, 255, .8)',
              shadowBlur: 0,
              margin: 0,
            },
            lineStyle: {
              type: 'dashed',
              color: '#b6b5b7',
            },
          },
          textStyle: {
            color: '#333',
            align: 'left',
            fontSize: 14,
          },
          formatter(params) {
            const res = `
              <div style="
                padding: 10px;
                box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                background: #fff;
                border-radius: 5px;">
                <div style="min-width: 120px;">
                  <p>${params[0].axisValueLabel}</p>
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <p><span style="display: inline-block;margin-right: 5px;border-radius: 10px;height: 10px; width: 10px;background-color: ${params[0].color};"></span>${params[0].seriesName}</p>
                    <p>${params[0].value}</p>
                  </div>
                </div>
              </div>`;
            return res;
          },
          position(point, params, dom, rect, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            const x = point[0]; //
            const y = point[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];
            let posX = 0; // x坐标位置
            let posY = 0; // y坐标位置

            if (x < boxWidth) {
              // 左边放不开
              posX = 5;
            } else {
              // 左边放的下
              posX = x - boxWidth;
            }

            if (y < boxHeight) {
              // 上边放不开
              posY = 5;
            } else {
              // 上边放得下
              posY = y - boxHeight;
            }

            return [posX, posY];
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {},
          },
        },
        grid: {
          height: '200',
          left: '0%',
          right: '2%',
          bottom: '4%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xArray,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#b6b5b7', // 坐标值得具体的颜色
            },
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#b6b5b7', // 坐标值得具体的颜色
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 10,
          },
          {
            start: 0,
            end: 10,
          },
        ],
        series: [
          {
            name: '留存率',
            type: 'line',
            lineStyle: {
              width: 2,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              normal: {
                color: '#768bf5', // 拐点颜色
                borderColor: '#768bf5', // 拐点边框颜色
                borderWidth: 3, // 拐点边框大小
              },
              emphasis: {
                color: '#768bf5', // hover拐点颜色定义
              },
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(171, 185, 249)',
                },
                {
                  offset: 1,
                  color: 'rgb(251, 252, 255)',
                },
              ]),
            },
            data: yArray,
          },
        ],
      };
    },
    // 用户平均停留市场
    renderbarChartStay(xArray, yArray) {
      return {
        color: ['#7a79ff'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter(params) {
            console.log(params);
            const res = `
            <div>
              <div style="min-width: 120px;">
                <p>${params[0].axisValueLabel}</p>
                <div style="display: flex;justify-content: space-between;align-items: center">
                  <p><span style="display: inline-block;margin-right: 5px;border-radius: 10px;height: 10px; width: 10px;background-color: ${params[0].color};"></span>停留时长</p>
                  <p>${params[0].value}</p>
                </div>
              </div>
            </div>`;
            return res;
          },
        },
        xAxis: {
          type: 'category',
          data: xArray,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          axisLabel: {
            textStyle: {
              color: '#b6b5b7', // 坐标值得具体的颜色
            },
          },
        },
        grid: {
          height: '180',
          left: '0%',
          right: '2%',
          bottom: '5%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          // 网格
          splitLine: {
            show: false,
          },
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          axisLabel: {
            type: 'value',
            formatter: '{value} 秒',
            textStyle: {
              color: '#b6b5b7', // 坐标值得具体的颜色
            },
          },
        },
        series: [
          {
            barWidth: 15, // 柱图宽度
            data: yArray,
            type: 'bar',
          },
        ],
      };
    },
    renderBarChart(analyzeDate = [], newUser = [], oldUser = [], totalUserArray = []) {
      this.barChart.clear(); // 消除当前实例
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter(params) {
            // eslint-disable-next-line no-shadow
            const [newUser, oldUser] = params;
            const {
              axisValueLabel, dataIndex, seriesName, value, color,
            } = newUser;
            const { seriesName: oldName, value: oldValue, color: oldColor } = oldUser;
            const res = `
              <div>
                <div style="min-width: 120px;">
                  <p>${axisValueLabel}</p>
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <p><span style="display: inline-block;margin-right: 5px;border-radius: 10px;height: 10px; width: 10px;background-color: #7a79ff;"></span>用户总数</p>
                    <p>${totalUserArray[dataIndex]}</p>
                  </div>
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <p><span style="display: inline-block;margin-right: 5px;border-radius: 10px;height: 10px; width: 10px;background-color: ${color};"></span>${seriesName}</p>
                    <p>${value}</p>
                  </div>
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <p><span style="display: inline-block;margin-right: 5px;border-radius: 10px;height: 10px; width: 10px;background-color: ${oldColor};"></span>${oldName}</p>
                    <p>${oldValue}</p>
                  </div>
                </div>
              </div>`;
            return res;
          },
        },
        legend: {
          data: ['新用户数', '旧用户数'],
        },
        grid: {
          height: '160',
          left: '0%',
          right: '2%',
          bottom: '8%',
          containLabel: true,
        },
        color: ['#ff8639', '#ffddc7'],
        xAxis: [
          {
            type: 'category',
            data: analyzeDate,
            // 设置轴线的属性
            axisLine: {
              lineStyle: {
                color: '#f2f2f2',
                // width: 8
              },
            },
            axisLabel: {
              textStyle: {
                color: '#b6b5b7', // 坐标值得具体的颜色
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            // 网格
            splitLine: {
              show: true,
              lineStyle: {
                color: '#f2f2f2',
                width: 1,
                type: 'solid',
              },
            },
            // 设置轴线的属性
            axisLine: {
              lineStyle: {
                color: '#f2f2f2',
                // width: 8
              },
            },
            // 数值
            axisLabel: {
              textStyle: {
                color: '#b6b5b7', // 坐标值得具体的颜色
              },
            },
          },
        ],
        series: [
          // {
          //   name: '用户总数',
          //   barWidth : 15,//柱图宽度
          //   type: 'bar',
          //   // stack: '用户数',
          //   // emphasis: {
          //   //   focus: 'series'
          //   // },
          //   data: totalUserArray,
          // },
          {
            name: '新用户数',
            barWidth: 15, // 柱图宽度
            type: 'bar',
            stack: '用户数',
            emphasis: {
              focus: 'series',
            },
            data: newUser,
          },
          {
            name: '旧用户数',
            barWidth: 15, // 柱图宽度
            type: 'bar',
            stack: '用户数',
            emphasis: {
              focus: 'series',
            },
            data: oldUser,
          },
        ],
      };
      // 绘制图表
      this.barChart.setOption(option);
    },
    handleResize() {
      clearTimeout(this.timeoutEvent);
      this.timeoutEvent = setTimeout(() => {
        this.barChart.resize(); // 重绘echart图表
        this.lineChartPv.resize(); // 重绘echart图表
        this.lineChartUv.resize(); // 重绘echart图表
        this.lineChartNew.resize(); // 重绘echart图表
        if (this.source !== 'BPS/BPS1') {
          this.lineChartJump.resize(); // 重绘echart图表
        }
        this.barChartStay.resize(); // 重绘echart图表
        this.lineChartRetention.resize(); // 重绘echart图表
        this.barChartTopEquipment.resize(); // 重绘echart图表
        this.barChartTopCity.resize(); // 重绘echart图表
        this.barChartTopSystem.resize(); // 重绘echart图表
        this.barChartTopApp.resize(); // 重绘echart图表
        this.barChartTopResolving.resize(); // 重绘echart图表
        this.barChartTopBrowser.resize();
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.color-green {
  color: #00af56;
}
.color-red {
  color: #f85149;
}
.color-gray {
  color: #a3a5b0;
}
.user-chart-box {
  height: 200px;
}
.small-chart-box {
  height: 220px;
}
.app-layout {
  min-width: 800px;
  padding: 20px;
}
</style>
